import React from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";

const ProjectDetailsModal = ({ show, onHide, data }) => {
  if (!data || Object.keys(data).length === 0) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      {data.images && data.images.length > 0 && (
        <div style={{ height: "300px", overflow: "hidden" }}>
          <img
            src={data.images[0]}
            alt={data.title}
            style={{ width: "100%", height: "auto", objectFit: "cover" }}
          />
        </div>
      )}
      <Modal.Header
        closeButton
        style={{
          backgroundColor: "#343a40",
          color: "#fff",
          borderBottom: "none",
        }}
      >
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          {data.url && (
            <Row className="mb-3">
              <Col className="text-center">
                <a
                  href={data.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-primary"
                >
                  Visit Project
                </a>
              </Col>
            </Row>
          )}
          <Row className="mb-3">
            <Col>
              <p>{data.description}</p>
            </Col>
          </Row>
          {data.technologies && (
            <Row>
              <Col>
                <h5>Technologies Used</h5>
                <div className="d-flex flex-wrap">
                  {data.technologies.map((tech, i) => (
                    <div
                      key={i}
                      className="me-3 mb-2 d-flex align-items-center"
                    >
                      <i
                        className={tech.class}
                        style={{ fontSize: "1.5rem", color: "#6c757d" }}
                      ></i>
                      <span className="ms-1">{tech.name}</span>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProjectDetailsModal;
